import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Query {
  /**
   * @description comma-separated string with possible values: `countries`, `currencies`, `videos`
   */
  expand?: string;
}

export interface ConfigurationResponse {
  allowedCountries?: string[];
  allowedCurrencies?: string[];
  videos?: {
    availableQuota: number;
    maxSize: number;
  };
}

export default (makeCall: MakeCall) => (query?: Query) =>
  makeCall<ConfigurationResponse>('GET', `/api/v2/listings/configuration`, {
    query,
  });
